import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=da6e61dc&"
import script from "./platform.vue?vue&type=script&lang=js&"
export * from "./platform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da6e61dc')) {
      api.createRecord('da6e61dc', component.options)
    } else {
      api.reload('da6e61dc', component.options)
    }
    module.hot.accept("./platform.vue?vue&type=template&id=da6e61dc&", function () {
      api.rerender('da6e61dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coupon/platform.vue"
export default component.exports